import { Component } from "@angular/core";
import { DashboardService } from "@app/main/modules/dashboard/dashboard.service";
import * as moment from "moment";
import { DynamicReportService } from "../../reports/_services/dynamicReports.service";
import { ReportTableRowDataSource } from "../../reports/enums/ReportTableRowDataSource";
import { IColumnHeader } from "../../reports/models/IColumnHeader";
import { IDataDefinition } from "../../reports/models/IReportDefinition";
import { IReportRow } from "../../reports/models/IReportRow";
import "./driver-behaviour-comparison.component.scss";

export interface IDriverScore {
    title: string,
    score: number;

    lowerRagBound: number;
    upperRagBound: number;
}

export interface IDriverComparison extends IDriverScore {
    subscores: IDriverScore[];

    otherMetrics: { title: string, value: string }[];
}

@Component({
    selector: "driver-behaviour-comparison",
    template: require("./driver-behaviour-comparison.component.html")
})
export class DriverBehaviourComparisonComponent {
    drivers: IDriverComparison[] = [];

    constructor(
        private readonly dashboardService: DashboardService,
        private readonly dynamicReportService: DynamicReportService
    ) {
        this.addDriver();
    }

    addDriver() {
        this.createReport().then(definition => {
            definition.TableDefinition.Rows.slice(0, 3);
        });
    }

    remove(driver: IDriverComparison) {
        this.drivers = this.drivers.filter(d => d != driver);
    }

    // ---

    loading = false;

    private createReport(): Promise<IDataDefinition> {
        var dataDefinition: IDataDefinition = {
            TableDefinition: { Headers: [] },
            RowDataSource: ReportTableRowDataSource.Driver,
            Parameters: {
                
                Start: moment().startOf("day").add(-1, "d").toDate(),
                End: moment().endOf("day").toDate()
            }
        };

        this.loading = true;

        return (this.dynamicReportService.getColumnHeaders() as Promise<IColumnHeader[]>)
            .then(headers => {
                const journeyHeaders = headers.filter(h => h.ReportType == "Journey");
                journeyHeaders.forEach(j => console.log(j));

                const totalScoreColumn = this.dashboardService.findColumn("Total Score", headers, "Journey");
                const drivingFuelColumn = this.dashboardService.findColumn("Driving Scores", headers, "Journey");

                dataDefinition.TableDefinition.Headers.push(totalScoreColumn);
                dataDefinition.TableDefinition.Headers.push(drivingFuelColumn);

                const journeyCount = this.dashboardService.findColumn("Number Of Journeys", headers, "Journey");
                dataDefinition.TableDefinition.Headers.push(journeyCount);

                const maxSpeed = this.dashboardService.findColumn("Max Speed", headers, "Journey");
                dataDefinition.TableDefinition.Headers.push(maxSpeed);

                const idleColumn = this.dashboardService.findColumn("Duration Idle", headers, "Journey");
                dataDefinition.TableDefinition.Headers.push(idleColumn);

                const durationInJourneyColumn = this.dashboardService.findColumn("Duration In Journey", headers, "Journey");
                dataDefinition.TableDefinition.Headers.push(durationInJourneyColumn);

                const distanceColumn = this.dashboardService.findColumn("Distance", headers, "Journey");
                dataDefinition.TableDefinition.Headers.push(distanceColumn);

                const fuelUsedColumn = this.dashboardService.findColumn("Fuel Used", headers, "Journey");
                dataDefinition.TableDefinition.Headers.push(fuelUsedColumn);

                return this.dashboardService.populateDataDefinition(dataDefinition).then(dataDefinition => {
                    this.mapDriverReportToScoreDefinition(dataDefinition);
                    return dataDefinition;
                });
            })
            .finally(() => {
                this.loading = false;
            });
    }

    private mapDriverReportToScoreDefinition(dataDefinition: IDataDefinition) {
        var driver = dataDefinition.TableDefinition.Rows[this.drivers.length + 1];
        this.drivers.push(this.createDriverScoreDefinition(driver, dataDefinition.TableDefinition.Headers));
    }

    private createDriverScoreDefinition(driverRow: IReportRow, headers: IColumnHeader[],): IDriverComparison {
        const subscores: IDriverScore[] = [];
        const otherMetrics: { title: string, value: string }[] = [];

        let lastScoreIndex = 0;
        for (var i = 2; i < headers.length; i++) {
            const cell = driverRow.Cells[i];

            if (!cell.MetaData || headers[i].Title.indexOf("Score") < 0) {
                continue;
            }

            lastScoreIndex = i;

            subscores.push({
                title: headers[i].Title.replace(" Score", ""),
                score: cell.Data,

                lowerRagBound: cell.MetaData.LowerRagBound,
                upperRagBound: cell.MetaData.UpperRagBound
            })
        }

        for (i = lastScoreIndex + 1; i < headers.length; i++) {
            const cell = driverRow.Cells[i];

            otherMetrics.push({
                title: headers[i].Title,
                value: cell.Data
            });
        }

        return {
            title: driverRow.Cells[0].Data,
            score: driverRow.Cells[1].Data,
            lowerRagBound: driverRow.Cells[1].MetaData.LowerRagBound,
            upperRagBound: driverRow.Cells[1].MetaData.UpperRagBound,

            otherMetrics: otherMetrics,

            subscores: subscores
        };
    }
}
